// Module
var code = "<div ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\"> <i class=\"material-icons close-modal no-expand\" ng-class=\"{show: hover}\" ng-click=\"$ctrl.closeModal()\"> clear </i> <nets-dialer card=\"$ctrl.card\" context=\"modal\" workflow=\"new-call\"></nets-dialer> </div> ";
// Exports
export default code;